/* Look D sticky sync. Loaded by sections/sk-pdp-sticky-bar-d.liquid
   (mouth-tape-a and mouth-tape-d) and sections/sk-pdp-sticky-bar-d2.liquid.
   This file only keeps the thumb and style·pack subtitle in sync.
   It does not add to cart. A and D scroll; D2 calls addToCart() from its markup.
   Price text is written by sleep-karma-pdp.js updateUI() into #sticky-price. */
(function () {
  if (window.__skStickyDInit) return;
  window.__skStickyDInit = true;

  function styleKey() {
    var selected = document.querySelector('.variant-option.selected');
    var key = selected && selected.getAttribute('data-style');
    if (key === 'slim' || key === 'full') return key;
    if (window.state && state.style === 'slim') return 'slim';
    return 'full';
  }

  function styleLabel(key) {
    var name = document.querySelector('.variant-option.selected .variant-option-name');
    var text = name && name.textContent.replace(/\s+/g, ' ').trim();
    if (text) return text;
    return key === 'slim' ? 'Slim Profile' : 'Full Coverage';
  }

  function packLabel() {
    var name = document.querySelector('.pack-card.selected .pack-name');
    if (name) {
      var text = '';
      for (var i = 0; i < name.childNodes.length; i++) {
        if (name.childNodes[i].nodeType === Node.TEXT_NODE) text += name.childNodes[i].textContent;
      }
      text = text.replace(/\s+/g, ' ').trim().replace(/\s+supply$/i, '');
      if (text) return text;
    }
    var pack = window.state && state.pack;
    if (pack === '1' || pack === '3' || pack === '6') return pack + ' Month';
    return '3 Month';
  }

  function fileName(url) {
    if (!url) return '';
    var path = String(url).split('?')[0];
    return path.slice(path.lastIndexOf('/') + 1);
  }

  // Cart drawer line items render variant.featured_image (snippets/cart-item.liquid
  // item.image). Those pouch URLs are printed on #sticky-product-thumb as
  // data-full / data-slim. The C gallery data-full / data-slim values are
  // lifestyle heroes and must not drive this thumb.
  function productSrc(key) {
    var thumb = document.getElementById('sticky-product-thumb');
    if (!thumb) return '';
    return thumb.getAttribute('data-' + key) || '';
  }

  function syncStickyCard() {
    var thumb = document.getElementById('sticky-product-thumb');
    var label = document.getElementById('sticky-variant-label');
    if (!thumb && !label) return;

    var key = styleKey();
    var styleName = styleLabel(key);
    var nextLabel = styleName + ' · ' + packLabel();
    var src = productSrc(key);

    if (label && label.textContent !== nextLabel) label.textContent = nextLabel;
    if (thumb && src && fileName(thumb.getAttribute('src')) !== fileName(src)) {
      thumb.src = src;
    }
    if (thumb) thumb.alt = styleName + ' bamboo mouth tape';
  }

  function wrap(name) {
    var original = window[name];
    if (typeof original !== 'function' || original.__skStickyD) return;
    function wrapped() {
      var result = original.apply(this, arguments);
      syncStickyCard();
      return result;
    }
    wrapped.__skStickyD = true;
    window[name] = wrapped;
  }

  function ensureWrapped() {
    wrap('selectStyle');
    wrap('selectPack');
  }

  function onChoiceClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('.variant-option, .pack-card, #refill-toggle')) return;
    ensureWrapped();
    syncStickyCard();
  }

  function init() {
    ensureWrapped();
    syncStickyCard();
    document.addEventListener('click', onChoiceClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
    document.addEventListener('DOMContentLoaded', function () {
      ensureWrapped();
      syncStickyCard();
    });
  }
})();
